import { render, staticRenderFns } from "./DesignsModal.vue?vue&type=template&id=7f545eac&scoped=true&"
import script from "./DesignsModal.vue?vue&type=script&lang=js&"
export * from "./DesignsModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignsModal.vue?vue&type=style&index=0&id=7f545eac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f545eac",
  null
  
)

export default component.exports